import React from "react";
import HeaderBread from "../../../components/HeaderBread";
import Layout from "../../../Layout";
import { useNavigate } from "react-router-dom";
import ExperienceInputs from "../../../components/Experience/ExperienceInputs";
import CustomHeaderTitle from "../../../components/constants/CustomHeaderTitle";
import LoginPageInput from "../../../components/LoginPage/LoginPageInput";

const CreateLoginPage = () => {
  const navigate = useNavigate();
  const navigation = [
    {
      title: "Home",
      route: "/",
    },
    {
      title: "Login Page List",
      route: "/website/webpages/login-page",
    },
    {
      title: "Add Login Page",
      route: "/website/webpages/login-page/add",
    },
  ];

  return (
    <Layout type={"create_per"} module_data={"login-page"}>
        <CustomHeaderTitle title={"Add Login Page Slider Images"}/>
      <HeaderBread navigation={navigation} title={"Add Login Page Slider Images"}></HeaderBread>
      <LoginPageInput slider={{}} />
    </Layout>
  );
};

export default CreateLoginPage;
